import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var SearchInput = function (_a) {
    var id = _a.id, name = _a.name, className = _a.className, value = _a.value, placeholder = _a.placeholder, required = _a.required, onChange = _a.onChange, innerRef = _a.innerRef;
    return (React.createElement("input", { id: id, name: name, value: value, className: cn(styles.searchInput, className, "js-gtm-search-input"), placeholder: placeholder, required: required, onChange: onChange, ref: innerRef, type: "text", autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", spellCheck: false }));
};
export default SearchInput;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchInput/index.tsx
// module id = 4nSq
// module chunks = 2